import './logo.css';

export default function Logo() {
    return (
        <a href="/">
            <div className="logo__container">
               <img className="logo__photo" src={"/photos/brlabs_logo_branco_png.png"} alt="" />
            </div>
        </a>
    );
}
